import { render, staticRenderFns } from "./CheckoutNotes.vue?vue&type=template&id=796317cf&scoped=true"
import script from "./CheckoutNotes.vue?vue&type=script&lang=js"
export * from "./CheckoutNotes.vue?vue&type=script&lang=js"
import style0 from "./CheckoutNotes.vue?vue&type=style&index=0&id=796317cf&prod&lang=scss&scoped=true"
import style1 from "./CheckoutNotes.vue?vue&type=style&index=1&id=796317cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796317cf",
  null
  
)

export default component.exports